<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="flex-between flex-center">
				<div class="user-login-title"><span>批量下单</span></div>
				
				<div class="user-button flex-end flex-center">
					<div class="user-button-icon" @click="downtemplate">下载模板</div>
					<el-upload :action="$apiBase + '/order/importOrder'" :headers="{authorization:token}" ref="uploadFile" :on-success="successImage" :limit="1">
						<div class="user-button-icon">导入订单</div>
					</el-upload>
				</div> 
			</div>
			
			<div class="order-list" v-if="total > 0">
				<div class="order-item" v-for="item in list" :key="item.id">
					<div class="order-top flex-between flex-center">
						<div class="order-top-title">{{item.orderNo}}</div>
						<div class="order-top-time flex-end flex-center">
							<img src="@/assets/images/time.png"/>
							<el-statistic :value="new Date(item.expectCancelTime)" format="HH时mm分ss秒" time-indices @finish="removeOrder(index)"></el-statistic>
						</div>
					</div>
					
					<div class="order-info flex-between flex-center">
						<img class="order-info-image" :src="item.goodsList[0].goodsSpecImage"></img>
						<div class="order-info-name"><span class="one">{{item.goodsList[0].goodsName}}</span></div>
						<div class="order-info-price">
							<div>￥{{item.meetPrice}}</div>
							<div>（含运费：￥{{item.freightPrice}}元）</div>
							<div>信用付</div>
						</div>
						
						<div class="order-info-button">
							<router-link :to="'/orderinfo?id='+(item.id*23+20)" target="_blank" class="order-info-button-see">查看详情</router-link>
							<div class="order-info-button-button" @click="changeStatusValue(item.id,index, -1)">取消订单</div>
						</div>
						
					</div>
					
				</div>
			</div>
			
			
			<div class="no-data" v-if="total == 0">
				<img src="@/assets/images/cart-no.png"/>
				<div>对不起，暂未导入订单</div>
			</div>
			
			
			<div class="cart-bottom-content">
				<div class="cart-bottom flex-end flex-center">
					
					<div class="cart-bottom-right flex-end flex-center">
						<div class="cart-bottom-right-text">
							共 <span>{{total}}</span> 个订单    |    订单合计: ¥{{totalPrice}}    |    应付总额: <span>¥{{totalPrice}}</span>
						</div>
						<div class="cart-bottom-right-button" @click="toSubmit">去支付</div>
					</div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import noData from '@/components/noData.vue'
import {createBatchPay} from "@/api/user"
export default {
	name: 'index',
	components:{
		noData
	},
	data(){
		return {
			list:[],
			totalPrice:0,
			total:0,
			token:""
		}
	},
	mounted() {
		this.token = this.$cookies.get('userToken');
	},
	methods:{
		successImage(e){
			if(e.code == 1000){
				this.list = e.data.orderList;
				this.totalPrice = e.data.totalMeetPrice;
				this.total = this.list.length;
			}else{
				this.$message.error(e.message);
			}
			this.$refs.uploadFile.clearFiles();
		},
		toSubmit(){
			let ids = [];
			this.list.map(item=>{
				ids.push(item.id);
			})
			if(ids.length == 0){
				return this.$message.error("暂无订单");
			}
			
			createBatchPay(ids).then(res=>{
				if(res.code == 1000){
					this.$router.push("/batchpay?id="+res.data);
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		downtemplate(){
			window.open(this.$apiBase + "/order/downloadImportTemplate");
		},
		removeOrder(index){
			this.list.splice(index, 1);
		},
		changeStatusValue(id,index, status){
			this.$alert('确定操作吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						updateOrderStatus({orderId:id,orderStatus:status}).then(res=>{
							if(res.code == 1000){
								this.list.splice(index, 1);
								this.$message.success("操作完成");
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
	.cart-bottom-content{
		background-color: #fff;
		padding: 30px 20px 40px;
		.cart-bottom{
			width: 1280px;
			height: 88px;
			background: #FEF6F6;
			.cart-bottom-right{
				.cart-bottom-right-text{
					font-size: 16px;
					color: #070B13;
					margin-right: 40px;
					span{
						color: #E91A12;
						&:last-of-type{
							font-size: 20px;
							margin-left: 12px;
						}
					}
				}
				.cart-bottom-right-button{
					width: 208px;
					height: 88px;
					background: #E91A12;
					font-size: 20px;
					font-weight: 500;
					line-height: 88px;
					text-align: center;
					color: #FFFFFF;
					cursor: pointer;
				}
			}
		}
	}
	
	.no-data{
		width: 100%;
		padding: calc(50vh - 400px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		div{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
		}
	}
	.user-button{
		.user-button-icon{
			width: 111px;
			height: 30px;
			border: 1px solid rgba(233, 26, 18, 0.3);
			font-size: 16px;
			line-height: 30px;
			color: #070B13;
			text-align: center;
			margin-left: 20px;
			cursor: pointer;
		}
	}
	.order-item{
		width: 100%;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		margin-top: 20px;
		.order-info{
			padding: 10px 0px 10px 20px;
			box-sizing: border-box;
			width: 100%;
			.order-info-image{
				width: 80px;
				height: 80px;
				border: 1px solid rgba(0, 0, 0, 0.1);
				flex: 0 0 82px;
				margin-right: 20px;
			}
			.order-info-name{
				font-size: 16px;
				color: #070B13;
				width: 100%;
				line-height: 40px;
				span{
					max-width: 300px;
					display: inline-block;
				}
			}
			.order-info-status{
				font-size: 16px;
				color: #070B13;
				flex: 0 0 100px;
				text-align: center;
			}
			.order-info-price{
				font-size: 14px;
				line-height: 22px;
				color: #070B13;
				text-align: center; 
				flex: 0 0 200px;
			}
			.order-info-button{
				border-left: 1px solid rgba(7, 11, 19, 0.1);
				width: 148px;
				text-align: center;
				flex: 0 0 148px;
				.order-info-button-button{
					width: 88px;
					height: 24px;
					border: 1px solid rgba(233, 26, 18, 0.3);
					font-size: 14px;
					line-height: 24px;
					color: #E91A12;
					text-align: center;
					margin: 0 auto 8px;
					cursor: pointer;
				}
				.order-info-button-see{
					width: 88px;
					height: 24px;
					border: 1px solid rgba(7, 11, 19, 0.3);
					font-size: 14px;
					line-height: 24px;
					color: #070B13;
					text-align: center;
					margin: 0 auto 8px;
					cursor: pointer;
					display: block;
				}
			}
		}
		.order-top{
			width: 100%;
			height: 46px;
			background: rgba(233, 26, 18, 0.04);
			padding:0px 20px;
			box-sizing: border-box;
			.order-top-title{
				font-size: 16px;
				color: #070B13;
				line-height: 46px;
			}
			.order-top-time{
				img{
					width: 20px;
					height: 20px;
					margin-right: 10px;
				}
			}
		}
	}
	.order-list{
		min-height: 680px;
		background-color: #fff;
		padding: 20px 20px 0px;
	}
	
	
	::v-deep .el-statistic{
		display: inline;
	}
	::v-deep .el-statistic .con{
		display: inline;
		color: rgba(233, 26, 18, 1);
		span{
			font-size: 16px;
		}
	}
	
</style>
